<template>
  <section class="px-14 pb-6 mt-4 sm-max:px-5 sm-max:mt-0 " :class="sectionClass">
    <div
      :class="['bg-greenBg flex lg:ml-36 md-max:flex-col border-2 border-[#358419] border-green md-max:p-5', newStyle ? 'xs-max:!block md-max:!p-8' : '']"
      :style="{ maxWidth: maxWidth + 'px' }">
      <div
        :class="['float-left', newStyle ? 'xs-max:!float-right xs-max:!w-[190px] xs-max:-mt-16 xs-max:-mr-16 xs-max:mb-2 xs-max:ml-4' : '']">
        <nuxt-img
          :class="['relative lg:right-40 lg:top-9 md-max:mb-2 m-auto md-max:pr-8 md:min-w-[311px] md:max-w-none', newStyle ? 'xs-max:!pr-0 xs-max:!min-w-0' : '']"
          width="326" height="368" loading="lazy" format="webp" :alt="imageAlt" :src="imageSrc"></nuxt-img>
      </div>
      <div
        class="float-right pt-8 pb-8 space-y-5 sm-max:pt-0 font-21 sm-max:text-base lg:-ml-32 md-max:text-center lg:pr-20 lg:pl-4"
        :class="[{ 'italic': isItalic }, newStyle ? 'xs-max:!text-left xs-max:!pt-0 xs-max:!float-none xs-max:!block' : '']">
        <div class="" :class="newStyle ? 'text-xl' : 'lg:text-xl md:text-lg text-15'" v-html="text1"></div>
        <div class="leading-6" :class="newStyle ? 'text-xl md-max:leading-8' : 'lg:text-xl md:text-lg text-15'"
          v-html="text2"></div>
        <div class="leading-8"
          :class="newStyle ? 'text-xl md-max:leading-8' : 'lg:text-xl md:text-lg text-15 md-max:leading-6'"
          v-html="text3">
        </div>
        <div class="leading-8"
          :class="newStyle ? 'text-xl md-max:leading-8' : 'lg:text-xl md:text-lg text-15 md-max:leading-6'">
          {{ text4 }}
        </div>
        <div class="leading-6"
          :class="newStyle ? 'text-xl md-max:leading-8' : 'lg:text-xl md:text-lg text-15 md-max:leading-6'"
          v-html="text5"></div>
      </div>
    </div>

  </section>
</template>

<script setup>

const props = defineProps({
  text1: {
    type: String,
    default: 'Oh. My. God.',
  },
  text2: {
    type: String,
    default: 'This was it.',
  },
  text3: {
    type: String,
    default: 'I don’t even remember the name of the coffee shop. But I remember the taste. \'Like heaven in a cup.',
  },
  text4: {
    type: String,
    default: 'It was to that coffee that I’ve compared everything else.',
  },
  text5: {
    type: String,
    default: 'And nothing measured up, until now.',
  },

  imageSrc: {
    type: String,
    default: '/assets/images/freebag-sect2-img2.png',
  },
  imageAlt: {
    type: String,
    default: 'coffee',
  },
  sectionClass: {
    type: String,
    default: '',
  },
  isItalic: {
    type: Boolean,
    default: true
  },
  maxWidth: {
    type: String,
    default: ''
  },
  newStyle: {
    type: Boolean,
    default: false
  }
})

defineBuilderComponent({
  friendlyName: "Comment",
  canHaveChildren: true,
  inputs: [
    {
      name: "text1",
      type: "richText",
      defaultValue: "Oh. My. God."
    },
    {
      name: "text2",
      type: "richText",
      defaultValue: "This was it."
    },
    {
      name: "text3",
      type: "richText",
      defaultValue: "I don’t even remember the name of the coffee shop. But I remember the taste. Like heaven in a cup."
    },
    {
      name: "text4",
      type: "richText",
      defaultValue: "It was to that coffee that I’ve compared everything else."
    },
    {
      name: "text5",
      type: "richText",
      defaultValue: "And nothing measured up, until now."
    },
    {
      name: "text6",
      type: "richText",
      defaultValue: "What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor."
    },
    {
      name: "text7",
      type: "richText",
      defaultValue: "The best tasting coffee, it turns out, is also the healthiest coffee."
    },
    {
      name: "text8",
      type: "richText",
      defaultValue: "The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen."
    },
    {
      name: "imageSrc",
      type: "file",
      allowedFileTypes: [
        "jpeg",
        "jpg",
        "png",
        "svg"
      ],
      defaultValue: "/assets/images/freebag-sect2-img2.png"
    },
    {
      name: "imageAlt",
      type: "text",
      defaultValue: "coffee"
    },
    {
      name: "buttonText",
      type: "text",
      defaultValue: "Save 50% Now"
    },
    {
      name: "sectionClass",
      type: "text",
      defaultValue: ""
    },
    {
      name: "isItalic",
      type: "boolean",
      defaultValue: true
    },
    {
      name: "maxWidth",
      type: "text",
      defaultValue: ""
    },
    {
      name: "newStyle",
      type: "boolean",
      defaultValue: false
    }
  ]
});
</script>